import { AirplaneInFlight, Bed, Camera, MoonStars, Path, ShoppingBag } from '@phosphor-icons/react';
import { Icon } from '@eti/components';
import { EventSegmentType } from '@eti/schema-types';
import { useDirection } from '@eti/providers';
import type { TripInfoType } from './constants';

interface TripEventIconProps {
  type: TripInfoType;
}
const TripEventIcon = ({ type }: TripEventIconProps) => {
  const { isRTL } = useDirection();

  const EVENT_SEGMENT_TYPE_TO_ICON = {
    [EventSegmentType.OvernightStay]: (
      <MoonStars aria-hidden data-testid="overnight-stay-icon" size={24} />
    ),
    [EventSegmentType.ChangeOfAirport]: (
      <Path aria-hidden data-testid="change-of-airport-icon" size={24} />
    ),
    [EventSegmentType.TransferToAirport]: (
      <Path aria-hidden data-testid="transfer-to-airport-icon" size={24} />
    ),
    [EventSegmentType.TransferToBus]: (
      <Path aria-hidden data-testid="transfer-to-bus-icon" size={24} />
    ),
    [EventSegmentType.TransferToTrain]: (
      <Path aria-hidden data-testid="transfer-to-train-icon" size={24} />
    ),
    [EventSegmentType.SelfTransfer]: (
      <Icon data-testid="self-transfer-icon" id="self-transfer" size="18px" />
    ),
    [EventSegmentType.ShortStopover]: (
      <ShoppingBag aria-hidden data-testid="short-stopover-icon" size={24} weight="fill" />
    ),
    [EventSegmentType.OneDayStopover]: (
      <Camera aria-hidden data-testid="one-day-stopover-icon" size={24} weight="fill" />
    ),
    [EventSegmentType.OneNightStopover]: (
      <Bed aria-hidden data-testid="one-night-stopover-icon" size={24} weight="fill" />
    ),
    [EventSegmentType.TwoNightsStopover]: (
      <Bed aria-hidden data-testid="two-nights-stopover-icon" size={24} weight="fill" />
    ),
    TECHNICAL_STOP: (
      <AirplaneInFlight
        aria-hidden
        data-testid="technical-stop-icon"
        mirrored={isRTL}
        size={20}
        weight="fill"
      />
    ),
  };

  return EVENT_SEGMENT_TYPE_TO_ICON?.[type] ?? null;
};

export default TripEventIcon;
